
define('text!plugins/keyvalue/setupTemplate.html',[],function () { return '';});

